import { AfterViewInit, Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { BaseUI } from '../../base.ui';
import { FullClient } from '../../../domain/data';
import { ParentEvents } from '../../../utils/parent-events.service';
import { ParentFormDirective } from '../../../directives/parent-form.directive';

@Component({
    selector: 'thr-full-data-four-natural-person',
    templateUrl: './full-data-four-natural-person.component.html',
    styleUrls: ['./full-data-four-natural-person.component.scss'],
})
export class FullDataFourNaturalPersonComponent extends BaseUI implements AfterViewInit, OnDestroy {
    public form: NgForm;
    public isFormValid = false;

    @Input()
    client: FullClient;

    @Input()
    isDisabled = false;

    @ViewChild('formDirective')
    formDirective: ParentFormDirective;

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.form = this.formDirective.controlContainer as NgForm;

        if (this.form) {
            this.form.statusChanges.subscribe(() => {
                setTimeout(() => {
                    this.isFormValid = this.form.valid;
                });
            });
        }
    }
}
